import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { stripFrontMatter } from "../../../utils/markdownHelpers";
import GeoSdkXamarinXamarin from "../../../assets/markDownFiles/geosafe/SDK-Xamarin.md";

const GeoSdkIntegrationXamarin = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (
      typeof GeoSdkXamarinXamarin === "string" &&
      GeoSdkXamarinXamarin.startsWith("/static")
    ) {
      fetch(GeoSdkXamarinXamarin)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(GeoSdkXamarinXamarin));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Geosafe
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoSdkIntegrationXamarin;
